// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3umhx","bigColWidth":"Table_bigColWidth__3MacA","biggerColWidth":"Table_biggerColWidth__2YG1q","row":"Table_row__15zvz","col":"Table_col__pt6Bw"};